import React, { memo, useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, FormInstance, Row, Typography, SunTextEditor } from 'components';
import { useTaskByIdQuery } from 'api';
import styles from './styles.module.scss';
import { PERMISSIONS } from 'constants/permissions';
import { EditIcon } from 'components/common/icons';
import { HasAccess } from 'components/common/accessControl';
import 'react-quill/dist/quill.snow.css';
import TextArea from 'antd/es/input/TextArea';
import { isObjectEmpty } from 'utils/helpers';

interface ISummaryDescription {
  form: FormInstance;
  editMode: boolean;
  id: string;
  isFinalStatus?: boolean;
  setEditMode: (editMode: boolean) => void;
  onUpdate: (data: { summary: string; description: string }) => void;
}

export const SummaryDescription = memo<ISummaryDescription>((props) => {
  const { editMode, form, id, isFinalStatus, setEditMode, onUpdate } = props;
  const { data: taskDetails = {} } = useTaskByIdQuery({ id });
  const [description, setDescription] = useState('');

  const onFinish = useCallback(() => {
    onUpdate({ description, summary: form.getFieldValue('summary') });
  }, [description, form, onUpdate]);

  useEffect(() => {
    if (editMode && !isObjectEmpty(taskDetails)) {
      setDescription(taskDetails.description);
      form.setFieldValue('summary', taskDetails.summary);
    }
  }, [taskDetails, form, editMode]);

  if (!editMode) {
    return (
      <Row justify={'space-between'} gutter={[0, 32]}>
        <Col span={22}>
          <Typography className={styles.summary}>{taskDetails.summary}</Typography>
        </Col>
        <Col span={2}>
          {!isFinalStatus && (
            <HasAccess role={PERMISSIONS.tasks.task.write}>
              <Button type={'link'} icon={<EditIcon />} onClick={() => setEditMode(true)} />
            </HasAccess>
          )}
        </Col>
        <Col span={24}>
          <div className="quill-content" dangerouslySetInnerHTML={{ __html: taskDetails.description }} />
        </Col>
      </Row>
    );
  }

  return (
    <Form form={form} requiredMark={false} layout="vertical" onFinish={onFinish}>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="Summary*" name="summary" rules={[{ required: true, message: 'Please enter task summary' }]}>
            <TextArea placeholder="Enter task summary" />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item label="Description*" rules={[{ required: true, message: 'Please enter task summary' }]}>
            <div style={{ height: '100%' }}>
              <SunTextEditor value={description} onChange={setDescription} />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row wrap={false} justify={'end'} className="gap-8 margin-t-12">
        <Button className={styles.status_btn} onClick={() => setEditMode(false)}>
          Cancel
        </Button>
        <Button disabled={false} type="primary" loading={false} onClick={() => form?.submit()}>
          Save
        </Button>
      </Row>
    </Form>
  );
});
